import { createApp } from '@backstage/frontend-defaults';
import { appModule } from './modules/appModule';
import { searchModule } from './modules/search/searchModule';

const app = createApp({
  features: [appModule, searchModule],
});

export default app.createRoot();
